import React from 'react'

import Image from 'next/image'

import {
  arrowForward,
  bankIcon,
  iphoneApproval100,
  walmartSpark,
} from '@ui/assets'
import { Container } from '@ui/components/Container'
import { StoreRatingsPill } from '@ui/components/StoreRatingsPill'
import { useSignUpHref } from '@ui/layout/signUpHref'

export const HeroInstantCash = ({
  className,
  title,
  description,
  cta,
  disclosure,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleClickEvent = () => {},
}: {
  className?: string
  title: React.ReactNode
  description: React.ReactNode
  cta?: string
  disclosure?: React.ReactNode
  handleClickEvent?: () => void
}) => {
  const signUpHref = useSignUpHref()
  return (
    <div className={className}>
      <div className="mb-6 flex items-center justify-center">
        <StoreRatingsPill />
      </div>
      <Container className="flex flex-col gap-8 lg:flex-row">
        {/* Hero Image Section */}
        <div className="relative order-2 h-[350px] w-[100%] lg:order-first lg:h-auto lg:w-1/2">
          <div className="absolute -bottom-1/4">
            {/* Walmart Card */}
            <div className="absolute bottom-[20%] left-[-2%] md:left-[5%] lg:bottom-[22%]">
              <div className="flex items-center gap-2 rounded-xl bg-white p-1 shadow-lg md:p-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0053e2] p-2 lg:h-12 lg:w-12">
                  <Image
                    src={walmartSpark}
                    className="h-full w-full"
                    alt="Walmart"
                  />
                </div>
                <p className="font-display pr-1 text-[12px] text-[#0a2d4a] lg:text-[18px]">
                  1% Cash Back
                </p>
              </div>
            </div>
            {/* Rewards card */}
            <div className="absolute right-[-5%] top-[15%] z-20 w-[150px] scale-90 rounded-2xl bg-white p-2 shadow-[0px_4px_0px_0px_rgba(10,45,74,0.1)] md:right-[5%] md:top-[30%] md:w-[200px] md:scale-100 md:p-3">
              <div className="mb-1 flex items-center justify-between lg:mb-2">
                <p className="font-display text-[14px] tracking-[-0.42px] text-[#0a3754] lg:text-[18px] lg:tracking-[-0.54px]">
                  Rewards
                </p>
                <Image
                  src={bankIcon}
                  width={20}
                  height={20}
                  alt=""
                  className="lg:h-6 lg:w-6"
                />
              </div>
              <div className="mb-1 h-px bg-[rgba(10,55,84,0.1)] lg:mb-2" />
              <p className="font-display text-[24px] uppercase text-[#29bfed] lg:text-[32px]">
                $1,348
              </p>
            </div>
            {/* Background */}
            <div className="relative">
              <div className="absolute bottom-0 bottom-[-15%] left-[-10%] right-[-10%] top-[10%] -z-10 rounded-full bg-sky-400 md:left-0 md:right-0 lg:bottom-[-25%]"></div>
              <Image
                alt="ATM app"
                src={iphoneApproval100}
                loading="eager"
                priority={true}
                className="h-[500px] w-full object-cover md:h-[550px] xl:h-[625px]"
              />
            </div>
          </div>
        </div>

        {/* Right content section */}
        <div className="flex flex-col justify-center gap-5 py-8 md:py-12 lg:w-1/2 xl:py-20">
          <h1 className="font-display text-[40px] leading-[0.95] tracking-tight text-[#0a2d4a] lg:text-[60px]">
            {title}
          </h1>
          <p className="font-display text-[20px] leading-[0.95] tracking-tight text-[#0a2d4a] lg:text-[32px]">
            {description}
          </p>
          <div className="mt-2 flex">
            <a
              onClick={handleClickEvent}
              href={signUpHref}
              className="inline-flex items-center gap-4 rounded-full bg-[#0a3754] py-1 pl-6 pr-1 transition-all hover:bg-[#0a3754]/90"
            >
              <span className="text-[17px] font-bold tracking-[-0.34px] text-white">
                {cta || 'Get Started'}
              </span>
              <div className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#29bfed]">
                <Image src={arrowForward} width={24} height={24} alt="" />
              </div>
            </a>
          </div>
          {disclosure && (
            <div className="content-disclosure text-dolphin-900">
              {disclosure}
            </div>
          )}
        </div>
      </Container>
    </div>
  )
}
